const input = document.getElementById("js-searchbar");
const searchContainer = document.querySelector(".search-container");
const searchResult = document.querySelector(".searchResult");
const phrases = ["Vous recherchez...", "Un service ?", "Une information ?"];
let phraseIndex = 0;
let animationTimeout;
let isUserTyping = false;

// Gère l'animation d'écriture du texte
function typeText(targetPhrase, charIndex) {
    input.placeholder = targetPhrase.slice(0, charIndex);

    if (charIndex < targetPhrase.length) {
        // Ingrémentation de lettre au texte
        animationTimeout = setTimeout(() => {
            typeText(targetPhrase, charIndex + 1);
        }, 100);
    } else {
        // Lorsque l'écriture est terminée, attend un délai avant d'effacer le texte
        animationTimeout = setTimeout(() => {
            eraseText(targetPhrase, targetPhrase.length);
        }, 1500);
    }
}

// Gère l'animation d'effacement du texte
function eraseText(targetPhrase, charIndex) {
    input.placeholder = targetPhrase.slice(0, charIndex);

    if (charIndex > 0) {
        // Supprime une lettre du texte
        animationTimeout = setTimeout(() => {
            eraseText(targetPhrase, charIndex - 1);
        }, 50);
    } else {
        // Lorsque l'effacement est terminé, passe à la phrase suivante et recommence l'animation
        phraseIndex = (phraseIndex + 1) % phrases.length;
        animationTimeout = setTimeout(() => {
            if (!isUserTyping) {
                typeText(phrases[phraseIndex], 0);
            }
        }, 1000);
    }
}

// Cette fonction démarre l'animation au chargement de la page
function startAnimation() {
    typeText(phrases[phraseIndex], 0);
}

// Gère l'événement lorsque l'input obtient le focus (l'utilisateur commence à taper)
input.addEventListener("focus", () => {
    isUserTyping = true;
    clearTimeout(animationTimeout);
    input.placeholder = "";
});

// Gère l'événement lorsque l'input perd le focus (l'utilisateur cesse de taper)
input.addEventListener("blur", () => {
    isUserTyping = false;
    clearTimeout(animationTimeout);
    startAnimation();
});

input.addEventListener("focusout", () => {
    setTimeout(() => {
        searchResult.classList.add('hideX');
        searchResult.classList.remove('showX');
    }, 200);
});

// Gère l'événement lorsque l'utilisateur saisit du texte dans l'input
input.addEventListener("input", () => {
    if (input.value) {
        // L'utilisateur est en train de taper, arrête l'animation
        isUserTyping = true;
        clearTimeout(animationTimeout);
        input.placeholder = "";
    } else {
        // L'utilisateur a effacé tout le texte, réactive l'animation
        isUserTyping = false;
        clearTimeout(animationTimeout);
        startAnimation();
    }
});

// Lance l'animation au chargement de la page
startAnimation();